import axios from 'axios';
import { GET_ITEMS, ADD_ITEM, DELETE_ITEM, ITEMS_LOADING } from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IItem } from '../../types/interfaces';

export const getItems = () => (dispatch: any) => {
  dispatch({ type: ITEMS_LOADING });
  axios
    .get('https://mern-shopping-list-odys.onrender.com/api/items')
    .then((res) =>
      dispatch({
        type: GET_ITEMS,
        payload: res.data,
      })
    )
    .catch(() =>
      dispatch({
        type: GET_ITEMS,
        payload: [],
      })
    );
};

export const addItem =
  (item: IItem) => (dispatch: Function, getState: Function) => {
    axios
      .post(
        'https://mern-shopping-list-odys.onrender.com/api/items',
        item,
        tokenConfig(getState)
      )
      .then((res) =>
        dispatch({
          type: ADD_ITEM,
          payload: res.data,
        })
      )
      .catch((err) =>
        dispatch(returnErrors(err.response.data, err.response.status))
      );
  };

export const deleteItem =
  (id: string) => (dispatch: Function, getState: Function) => {
    axios
      .delete(
        `https://mern-shopping-list-odys.onrender.com/api/items/${id}`,
        tokenConfig(getState)
      )
      .then((res) =>
        dispatch({
          type: DELETE_ITEM,
          payload: id,
        })
      )
      .catch((err) =>
        dispatch(returnErrors(err.response.data, err.response.status))
      );
  };

export const setItemsLoading = () => {
  return {
    type: ITEMS_LOADING,
  };
};
